import React from 'react';
import useBookstatProcessingStatus from '../../core/modules/book/hooks/useBookstatProcessingStatus';
import BookstatStatusBanner from './BookstatStatusBanner';

const BookstatBanner: React.FC = () => {
  const { data, isLoading, isError } = useBookstatProcessingStatus();

  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <BookstatStatusBanner
        status='error'
        message={
          `Bookstat Processing information is currently unavailable.
          Please refresh the page or try again shortly.`
        }
      />
    );
  }

  if (data?.status === 'delayed' || data?.status === 'error') {
    return (
      <BookstatStatusBanner
        status={data.status}
        message={
          data.message ||
          'Bookstat is taking longer than expected to process data. We’re working on it.'
        }
      />
    );
  }

  return null;
};

export default BookstatBanner;
